import React from 'react';
import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import Check from '@material-ui/icons/CheckCircleOutline';
import Circle from '@material-ui/icons/RadioButtonUnchecked';
import { isDefined } from 'lib/typeInference';
import { useCurrencyString } from 'lib/useCurrencyString';
import { IAdjustmentLocalResource } from 'components/order/model/Order';
import { IAdjustmentReadResourceV22 } from 'components/basket/model/Basket';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1)
    },
    text: {
        fontSize: '14px',
        fontWeight: 400
    }
}));

interface PayAwardItemProps {
    item: IAdjustmentLocalResource | IAdjustmentReadResourceV22;
    onClick: (awardId: string) => void;
    selected?: boolean;
}

export const PayAwardItem: React.FC<PayAwardItemProps> = ({ item, onClick, selected }) => {
    const classes = useStyles();
    const getCurrencyString = useCurrencyString();
    const handleClick = React.useCallback(() => {
        if (isDefined(item.awardId)) {
            onClick(item.awardId);
        }
    }, [item, onClick]);
    const value = React.useMemo(() => {
        if ('totalValue' in item) {
            return item.totalValue ? ` (${getCurrencyString(item.totalValue)})` : '';
        }
        return ` (${getCurrencyString(item.value * (item.quantity ?? 1))})`;
    }, [getCurrencyString, item]);
    return (
        <Box onClick={handleClick} className={classes.root}>
            <Typography className={classes.text}>
                {item.description}
                {value}
            </Typography>
            {selected ? <Check color="inherit" /> : <Circle color="inherit" />}
        </Box>
    );
};
